export const OPPORTUNITIES_FETCH = 'OPPORTUNITIES_FETCH',
  OPPORTUNITY_OPTIONS_FETCH = 'OPPORTUNITY_OPTIONS_FETCH',
  OPPORTUNITY_OPTION_GET = 'OPPORTUNITY_OPTION_GET';
